import { ResourceState } from "./types";

export const resourceStateInit: ResourceState = {
  error: null,
  list: {
    items: null,
    cached: {},
    page: 0,
    hasMore: true,
  },
};

export default resourceStateInit;
